module.exports = __webpack_public_path__ + "img/2.14d5b4ea.png";